
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sg/guide-and-tool/singapore-grants-and-incentives",
      function () {
        return require("private-next-pages/sg/guide-and-tool/singapore-grants-and-incentives/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sg/guide-and-tool/singapore-grants-and-incentives"])
      });
    }
  